import React from 'react'
import styles from './styles.module.scss'
import { NumericFormat } from 'react-number-format';

const ResultCallout = ({ result }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>Din beräknade buffert är</div>
      <div className={styles.sum}>
        <NumericFormat value={result} thousandSeparator=' ' displayType='text' />{' '}
        kr
      </div>
      <p className={styles.text}>
        Baserat på de utgifter som du angav och hur många månader du vill att
        pengarna ska räcka kommer detta att täcka dina utgifter, helt utan annan
        inkomst.
      </p>
    </div>
  )
}

export { ResultCallout }
